window.MD_Firebase = (function () {

  let db   = null;
  let auth = null;

  function init() {
    if (!window.firebase || !window.MD_FIREBASE_CONFIG) {
      console.error('Firebase no disponible');
      return;
    }

    firebase.initializeApp(window.MD_FIREBASE_CONFIG);

    if (firebase.firestore) {
      db = firebase.firestore();
      db.enablePersistence({ synchronizeTabs: true })
        .catch(function (err) {
          if (err.code === 'failed-precondition') {
            console.warn('Persistencia: múltiples tabs abiertas');
          } else if (err.code === 'unimplemented') {
            console.warn('Persistencia no disponible en este browser');
          }
        });
    }
    if (firebase.auth) auth = firebase.auth();
  }

  function getDb()   { return db;   }
  function getAuth() { return auth; }

  return { init, getDb, getAuth };

})();